// extracted by mini-css-extract-plugin
export default {"root":"Map_root__af+Ao","loader":"Map_loader__rRBy5"};